import Swal from 'sweetalert2';

const _swal = (type, title, config) => {
  const fireConfig = undefined === config ? {} : { ...config };
  return Swal.fire({
    width: '400px',
    backdrop: false,
    type,
    icon: type,
    title,
    showConfirmButton: false,
    timer: 4000,
    ...fireConfig,
  });
};

export const swalSuccess = (title, config) => _swal('success', title, config);

export const swalWarning = (title, config) => _swal('warning', title, config);
